<template>
    <div>
        <component v-if="instrumentCardViewComponent"
                   :is="instrumentCardViewComponent"
                   :instrument="instrument"
                   :is-compact="isCompact"
                   :is-slim="isSlim"
                   :show-sticky="showSticky"
                   :is-address-editable="isAddressEditable"
                   @open-sticky="$emit('open-sticky')"
                   @update-contact="updateContact($event)"/>
        <slot v-else name="noInstrument">
            <p class="text-muted">There is no instrument related to this record.</p>
        </slot>
    </div>
</template>

<script>
    import PaymentCardCardView from './views/payment-card-view';
    import AchCardView from './views/ach-view';
    import PaypalCardView from './views/paypal-view';
    import PaidOutsideView from './views/paid-outside-view';
    import PaymentInstrumentModel from '@/common/models/payment-instrument-model';

    export default {
        name: 'v-payment-instrument',
        props: {
            instrument: [Object, Boolean],
            isCompact: {
                type: Boolean,
                default: true,
            },
            isSlim: {
                type: Boolean,
                default: false,
            },
            showSticky: Boolean,
            isAddressEditable: {
                type: Boolean,
                default: true,
            },
        },
        computed: {
            instrumentCardViewComponent() {
                if (!this.instrument) {
                    return false;
                }
                const method = this.instrument.getMethod !== undefined
                    ? this.instrument.getMethod()
                    : PaymentInstrumentModel.getPaymentMethod(this.instrument);
                switch (method) {
                    case PaymentInstrumentModel.Methods.paymentCard:
                        return PaymentCardCardView;
                    case PaymentInstrumentModel.Methods.ach:
                        return AchCardView;
                    case PaymentInstrumentModel.Methods.paypal:
                        return PaypalCardView;
                    case PaymentInstrumentModel.Methods.cash:
                        return PaidOutsideView;
                    default:
                        return false;
                }
            },
        },
    };
</script>
